import axios from 'axios'
import { uri } from '../help/Api'
import { sto } from '../Context/InshData';

export const URL = uri + 'Customers';

export function create(data) {
    return axios.post(URL, data);
}

export function update(data) {
    return axios.put(URL, data);
}
export function remove(id) {
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
        Urls = `?id=${id}`
    } else {
        Urls = `?id=${id}&&db_name=${sto?.db_name}`
    }
    return axios.delete(URL + Urls)
}

export default { create, update, remove, URL }